import React from "react";

interface LocationProps {
  q?: any;
  onCloseClick?: (e: any) => void;
}

const Location: React.FC<LocationProps> = ({q, onCloseClick}) => {

  let blurb = q.blurb.replaceAll(/(\r\n|\n|\r)/g, "<br>\n");

  return (<div className="question location" style={{backgroundColor: q.bg_color || '#fdfdfdeb', color: q.text_color || '#000'}}>
    <button className="close-btn" style={{color: q.text_color || '#000'}} onClick={onCloseClick}>x</button>
    {q.img && <img src={q.img} className="question_img" alt="" />}
    <h2>{q.title}</h2>
    {q.opening_times && <h4>{q.opening_times}</h4>}
    {q.location && <h4>{q.location}</h4>}
    <p dangerouslySetInnerHTML={{__html:blurb}}></p>
  </div>);
};


export default Location;